/* eslint-disable react-hooks/exhaustive-deps */
import "./previousNewsletterForm.scss";
import "../../../RetireePortalToggle/RetireePortalToggle.scss";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import FileInput from "../../../fileInput/fileInput";
import { Formik } from "formik";
import * as Yup from "yup";
import * as previousNewsletterAction from "../../../../redux/actions/previousNewsletter.action";
import * as memberAction from "../../../../redux/actions/member.action";
import * as memberGroupAction from "../../../../redux/actions/memberGroup.action";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import Select from "react-select";
import { getTheme } from "../../../../helpers/select.theme";
import {
  getInitialMemberValues,
  getMemberOptions,
  processMemberOptions,
  formatGroupLabel,
  getRoleOptions,
} from "../../../../helpers/select";
import { useTranslation } from "react-i18next";
import * as React from "react";
import ModalConfirmation from "../../../modalconfirmation/ModalConfirmation";
import * as roleAction from "../../../../redux/actions/role.action";
import { customStyles } from '../../../../helpers/select.custom';

const PreviousNewsletterForm = () => {
  const dispatch = useDispatch();
  const { entityId } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [renderSuccessAlert, setRenderSuccessAlert] = useState(false);
  const [submittedForm, setSubmittedForm] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [memberOptions, setMemberOptions] = useState([]);
  const MAX_FILE_SIZE = 10 * 1024 * 1024; //10MB for PDFs
  const VALID_FILE_TYPES_PDF = ["application/pdf"];
  const [customResetForm, setCustomResetForm] = useState(() => {});
  const [showExitModal, setShowExitModal] = useState(false);
  const [roleOptions, setRoleOptions] = useState([]);

  const {
    newsletterDetails,
    newsletter,
    error,
    memberList,
    memberGroupList,
    roleList,
  } = useSelector((state) => ({
    newsletterDetails: state.previousNewsletter.previousNewsletterDetails,
    newsletter: state.previousNewsletter.previousNewsletter,
    error: state.previousNewsletter.previousNewsletterError,
    memberList: state.member.memberSelectList,
    memberGroupList: state.memberGroup.memberGroupSelectList,
    roleList: state.role.roleList,
  }));

  // Flatten the file structure for FileInput component
  const getInitialFileValue = (pdfFileData) => {
    // Handle flat structure (direct object)
    if (pdfFileData && !pdfFileData.data) {
      const { name, url, mime } = pdfFileData;
      return {
        name,
        url,
        type: mime,
        mime,
      };
    }

    // Handle nested structure (Strapi v4 format)
    if (!pdfFileData?.data?.attributes) return "";

    const { name, url, mime } = pdfFileData.data.attributes;
    return {
      name,
      url,
      type: mime,
      mime,
      // Keep the original structure for validation
      data: pdfFileData.data
    };
  };

  const initialValues = {
    titleForLeftMenu: entityId ? (newsletterDetails?.data?.attributes?.titleForLeftMenu || newsletterDetails?.titleForLeftMenu || "") : "",
    pdfFile: entityId ? getInitialFileValue(newsletterDetails?.data?.attributes?.pdf || newsletterDetails?.pdf) : "",
  };

  const formSchema = Yup.object().shape({
    titleForLeftMenu: Yup.string()
      .required("Required field")
      .max(50, "Short label must be 50 characters or less"),
    pdfFile: Yup.mixed()
      .required("Required field")
      .test(
        "is-correct-size",
        "File too large",
        (value, _) => {
          // If it's an existing file (object from Strapi), skip size validation
          if (value && typeof value === 'object' && !value.size) {
            return true;
          }
          return (value?.size || 0) <= MAX_FILE_SIZE;
        }
      )
      .test(
        "is-correct-format",
        "Invalid file extension. Only PDF files are allowed.",
        (value, _) => {
          // If no value, fail validation
          if (!value) return false;
          
          // If it's an existing file (object from Strapi), check the nested structure
          if (typeof value === 'object' && value.data?.attributes?.mime) {
            return VALID_FILE_TYPES_PDF.includes(value.data.attributes.mime);
          }
          
          // If it's a new file upload, check type or mime
          if (value.type || value.mime) {
            return VALID_FILE_TYPES_PDF.includes(value.type || value.mime);
          }
          
          return false;
        }
      )
  });
      
  const onSubmitForm = async (values, { resetForm }) => {
    setDisableSubmit(true); //Disable submit button

    const formData = new FormData();

    console.log('values', values)

    const { titleForLeftMenu, pdfFile } = values;

    const formBody = {
      titleForLeftMenu,
      current_newsletter: false
    };

    formData.append("data", JSON.stringify(formBody));

    // Only append file if it's a new file upload (has a size property)
    if (pdfFile && pdfFile.size) {
      formData.append("files.pdf", pdfFile);
    }

    if (entityId) {
      await previousNewsletterAction.update(dispatch, entityId, formData);
    } else {
      await previousNewsletterAction.create(dispatch, formData);
    }

    setSubmittedForm(true); // Flag to make sure that the form was submitted
    setDisableSubmit(false); //Reenable submit button
  };

  useEffect(() => {
    if (entityId) {
      //If id is passed as a parameter then load initial values
      previousNewsletterAction.fetchDetails(dispatch, entityId);
    }
  }, [dispatch, entityId]);

  useEffect(() => {
    //Render success alert and redirect
    if (submittedForm && newsletter) {
      setRenderSuccessAlert(true);
      if (!entityId) {
        customResetForm();
      }
    }
  }, [entityId, newsletter, submittedForm, navigate]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={formSchema}
      onSubmit={onSubmitForm}
    >
      {(formik) => {
        const {
          handleChange,
          handleSubmit,
          errors,
          touched,
          handleBlur,
          setFieldValue,
          values,
          resetForm,
        } = formik;

        return (
          <div className="previous-newsletter">
            <div className="previous-newsletter-container">
              {error && <Alert variant="danger">{error}</Alert>}
              {renderSuccessAlert && (
                <Alert
                  variant="success"
                  onClose={() => {
                    setRenderSuccessAlert(false);
                  }}
                >
                  {entityId
                    ? "Newsletter updated successfully"
                    : "Newsletter created successfully"}
                </Alert>
              )}
              <div className="previous-newsletter-header">
                <h1 className="previous-newsletter-title">
                  {entityId
                    ? "Edit Previous Medicare Newsletter"
                    : "New Previous Medicare Newsletter"}
                </h1>
              </div>
              <Form className="previous-newsletter-form">
                <div className="previous-newsletter-form-layout">
                  <div className="form-row">
                    <div className="form-input">
                      <Form.Label>Short Label for Left Menu</Form.Label>
                      <Form.Control
                        name="titleForLeftMenu"
                        value={values.titleForLeftMenu}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={errors.titleForLeftMenu && touched.titleForLeftMenu}
                        placeholder="Max 50 characters"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.titleForLeftMenu}
                      </Form.Control.Feedback>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-input">
                      <Form.Label>PDF File</Form.Label>
                      <FileInput
                        title="Browse a PDF File"
                        allowedTypes={"PDF"}
                        value={values?.pdfFile}
                        customFieldName={"pdfFile"}
                        setFieldValue={setFieldValue}
                        errorMessage={errors.pdfFile}
                      />
                      <div
                        style={{
                          width: "100%",
                          marginTop: "0.25rem",
                          fontSize: ".875em",
                          color: "#dc3545",
                          display: "block",
                        }}
                      > 
                        {errors.pdfFile}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-action-group">
                  <Button
                    onClick={() => {
                      if (formik.dirty && !renderSuccessAlert) {
                        setShowExitModal(true);
                      } else {
                        window.history.back();
                      }
                    }}
                    className="form-action"
                    variant="outline-primary"
                  >
                    {t("buttons.back")}
                  </Button>
                  <Button
                    type="submit"
                    className="form-action form-action-primary"
                    variant="outline-primary"
                    onClick={(e) => {
                      handleSubmit(e);
                      setCustomResetForm(() => resetForm);
                    }}
                    disabled={disableSubmit}
                  >
                    {t("buttons.save")}
                  </Button>
                </div>
              </Form>
            </div>
            <ModalConfirmation
              show={showExitModal}
              handleShow={setShowExitModal}
              title={t("modalconfirmation.titleExit")}
              mainAction={() => setShowExitModal(false)}
              secondaryAction={() => window.history.back()}
              question={t("modalconfirmation.exitquestion")}
              mainButton={t("modalconfirmation.continue")}
              secondaryButton={t("modalconfirmation.yesleave")}
            />
          </div>
        );
      }}
    </Formik>
  );
};

export default PreviousNewsletterForm;